import type { Nullable } from "../../typescript"

export default function firstOrNil<T>(list: Nullable<Array<T>>): Nullable<T> {
  return list?.[0]
}